<template>
  <div>
    <banner-list-add-new
      :is-add-new-banner-sidebar-active.sync="isAddNewBannerSidebarActive"
      :id="id"
      :banner-data="bannerData"
      @refetch-data="refetchData"
      @show-message="showMessage"
    />
    <b-card no-body v-if="user_id == 1">
      <b-card-header class="pb-50">
        <h5>Filter</h5>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col cols="12" md="3" class="mb-md-0 mb-2">
            <label>Company</label>
            <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="userOptions"
            label="name"
            class="w-100"
            :reduce="(val) => val.id"
            v-model="userFilter"
          />

          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button variant="primary" @click="handleAdd()">
                <span class="text-nowrap">Add Banner</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refBannerListTable"
        class="position-relative"
        :items="fetchBanners"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #cell(banner_image_path)="data">
          <b-img
            rounded
            blank-color="#5A8DEE"
            alt="Rounded image"
            :src="data.item.banner_image_url"
            class="d-inline-block mr-1 mb-1 banner-image"
          />
        </template>
        <!-- Column: is_active -->
        <template #cell(is_active)="data">
          <feather-icon
            v-if="data.item.is_active"
            icon="CheckIcon"
            size="18"
            class="mr-50 text-success"
          />
        </template>
        <template #cell(banner_category_id)="data">
          {{ data.item.category.name }}
        </template>
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item @click="editBanner(data.item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>

            <b-dropdown-item @click="confirmDelete(data.item.id)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
              {{ dataMeta.of }} entries</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalBanners"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BImg,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";

import bannerStoreModule from "../bannerStoreModule";
import useBannersList from "./useBannersList";
import BannerListAddNew from "./BannerListAddNew.vue";
import { getUserData } from "@/auth/utils";
import { getImgPath } from "@/libs/helper";

export default {
  components: {
    BImg,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,

    vSelect,
    BannerListAddNew,
    BCardHeader,
    BCardBody,
  },
  methods: {
    resetBannerData() {
      this.bannerData = {
        id: 0,
        is_active: 1,
        // store_id: getUserData().store_id,
        // banner_main_title:'',
        // banner_subtitle1: '',
        // banner_subtitle2: '',
      };
    },
    handleAdd() {
      this.id = 0;
      this.resetBannerData();
      this.isAddNewBannerSidebarActive = true;
    },
    confirmDelete(id) {
      this.$swal({
        title: "Are you sure?",
        text: "Your action is final and you are not able to recover the data.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          console.log("result.value", result.value);
          store
            .dispatch("bar-banner/deleteBanner", { id: id })
            .then((response) => {
              this.refetchData();
              this.showMessage(
                "Success",
                response.data.message,
                "CheckIcon",
                "success"
              );
            })
            .catch((error) => {
              console.log(error);
              //this.showMessage('Fail', error.response.data.message, 'HeartIcon', 'danger')
            });
        }
      });
    },
    editBanner(item) {
      this.id = item.id;
      this.bannerData = { ...item };
      this.isAddNewBannerSidebarActive = true;
    },
  },
  data() {
    return {
      id: 0,
      bannerData: {},
      getImgPath,
    };
  },
  computed: {
    user_id() {
      return getUserData().id;
    },
  },
  setup() {
    const BAR_BANNER_STORE_MODULE_NAME = "bar-banner";
    const isAddNewBannerSidebarActive = ref(false);

    if (!store.hasModule(BAR_BANNER_STORE_MODULE_NAME))
      store.registerModule(BAR_BANNER_STORE_MODULE_NAME, bannerStoreModule);

    onUnmounted(() => {
      if (store.hasModule(BAR_BANNER_STORE_MODULE_NAME))
        store.unregisterModule(BAR_BANNER_STORE_MODULE_NAME);
    });

    const {
      fetchBanners,
      tableColumns,
      perPage,
      currentPage,
      totalBanners,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refBannerListTable,
      refetchData,
      getBannerImage,
      categoryOptions,
      showMessage,
      userOptions,
      userFilter,
    } = useBannersList();

    return {
      //SideBar
      isAddNewBannerSidebarActive,
      fetchBanners,
      tableColumns,
      perPage,
      currentPage,
      totalBanners,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refBannerListTable,
      refetchData,
      getBannerImage,
      categoryOptions,
      showMessage,
      userOptions,
      userFilter,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.banner-image {
  width: 300px;
  height: 150px;
  object-fit: contain;
}
</style>

